module.exports = __webpack_public_path__ + "static/media/0026_LES_MURS_SLOE_W_VSL2100.69654cf6.webp";